import React, { useState } from "react";

const faqs = {
  Users: [
    {
      question: "What is Pink Help?",
      answer:
        "Pink Help is the world’s first women-focused global platform that connects women with trusted services in 200+ countries.",
    },
    {
      question: "Is Pink Help available in my country?",
      answer:
        "We are currently active in 60+ countries and expanding every week. Check your country’s Pink Page portal.",
    },
    {
      question: "Are the services free?",
      answer:
        "Many listings are free to access. Some premium services may charge a fee, clearly mentioned in their profiles.",
    },
    {
      question: "Can I get legal or health support anonymously?",
      answer:
        "Yes. Many providers respect confidentiality and offer anonymous consultations.",
    },
    {
      question: "Do I need to register to use Pink Help?",
      answer:
        "No registration is required to browse, but to submit a help request, basic contact info is needed for follow-up.",
    },
    {
      question: "How do I know which services are trustworthy?",
      answer:
        "All listings go through a verification process to ensure credibility and relevance to women’s needs.",
    },
    {
      question: "Can I request help in my local language?",
      answer:
        "Yes. Our help request form supports multiple languages, and we aim to match you with a local-language provider.",
    },
    {
      question: "What happens after I submit a help request?",
      answer:
        "Your request is reviewed and forwarded to a relevant provider who will contact you directly, if available.",
    },
    {
      question: "Can men use the platform too?",
      answer:
        "While our services are designed for women, some public resources may be visible to all users.",
    },
    {
      question: "Can I become a country ambassador or volunteer?",
      answer:
        "Yes! You can apply through the 'Become an Ambassador' section on the website.",
    },
  ],

  Advertisers: [
    {
      question: "How can I advertise on Pink Help?",
      answer:
        "You can apply for a standard or premium listing by visiting our 'Advertise' section.",
    },
    {
      question: "What’s the benefit of becoming a premium partner?",
      answer:
        "Premium partners get homepage visibility, top placement, larger ad space, and social media exposure.",
    },
    {
      question: "Is there exclusivity for ad categories?",
      answer:
        "Yes. We offer one exclusive premium partner per category, per country.",
    },
    {
      question: "How do I know my service is eligible?",
      answer:
        "Our team verifies all applications. Priority is given to services focused on helping women.",
    },
    {
      question: "How long does my listing stay active?",
      answer:
        "Listings are renewed monthly or annually based on your chosen package.",
    },
    {
      question: "Can I advertise in more than one country?",
      answer:
        "Yes. Multi-country listings are available for international organizations and vendors.",
    },
    {
      question: "Do you support e-commerce listings?",
      answer:
        "Yes. Our E-Commerce Portal allows product-based businesses to sell to women globally.",
    },
    {
      question: "Can I update or manage my listing after approval?",
      answer:
        "Yes. You’ll receive login access to manage your profile, images, and contact details.",
    },
    {
      question: "How are leads from help requests forwarded to us?",
      answer:
        "If a help seeker selects your category, you’ll be notified with their details (with consent).",
    },
    {
      question: "Can NGOs or non-profits advertise for free?",
      answer:
        "We offer limited sponsored listings for verified non-profit organizations serving women.",
    },
  ],
};

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState({
    Users: null,
    Advertisers: null,
  });

  const toggle = (category, index) => {
    setOpenIndex((prev) => ({
      ...prev,
      [category]: prev[category] === index ? null : index,
    }));
  };

  return (
    <section className="bg-white py-16 px-6 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold text-center text-pink-600 mb-4">
        Frequently Asked Questions
      </h2>
      <p className="text-center text-gray-600 mb-12">
        Have questions? We've got answers for both users and advertisers.
      </p>

      {Object.keys(faqs).map((category) => (
        <div key={category} className="mb-10">
          <h3 className="text-2xl font-semibold text-pink-500 mb-6">
            {category} FAQs
          </h3>
          <div className="space-y-4">
            {faqs[category].map((faq, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-md p-4 shadow-sm"
              >
                <button
                  className="w-full text-left flex justify-between items-center"
                  onClick={() => toggle(category, idx)}
                >
                  <span className="text-lg font-medium text-gray-800">
                    {faq.question}
                  </span>
                  <span className="text-xl text-pink-500">
                    {openIndex[category] === idx ? "-" : "+"}
                  </span>
                </button>
                {openIndex[category] === idx && (
                  <p className="mt-3 text-gray-600">{faq.answer}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
};

export default FaqSection;
